import { Link } from '@wartek-id/link'

import { formatDateOnly } from '@/utils/date'
import { trackClickOpenVervalByNpyp } from '@/utils/tracker/modules/datainduk'
import { SatDikDetail } from '@/apis/types'

import { VERVAL_YAYASAN_BASE_URL } from '@/modules/DataInduk/constant'

import { KeyValTable } from '@/components/KeyValTable'

type Props = {
  data?: SatDikDetail
}

export function TabDocPerijinan({ data }: Props) {
  return (
    <KeyValTable
      rows={[
        {
          key: 'kementrian-pembina',
          displayName: 'Kementrian Pembina',
          value: data?.kementerianPembina || '-',
        },
        {
          key: 'naungan',
          displayName: 'Naungan',
          value: data?.namaYayasan || '-',
        },
        {
          key: 'npyp',
          displayName: 'NPYP',
          value: data?.npyp || '-',
          CustomValueComponent: ({ value }) => {
            if (value === '-') return value
            return (
              <Link
                href={`${VERVAL_YAYASAN_BASE_URL}?yayasan_id=${data?.yayasanId}&utm_source=portal-satu-data`}
                underline={false}
                rel="noopener noreferrer"
                target="_blank"
                onClick={() => {
                  trackClickOpenVervalByNpyp({
                    npyp: value,
                  })
                }}
              >
                {value}
              </Link>
            )
          },
        },
        {
          key: 'no-sk',
          displayName: 'No. SK Pendirian',
          value: data?.skPendirianSekolah || '-',
        },
        {
          key: 'tgl-sk',
          displayName: 'Tanggal SK Pendirian',
          value: data?.tanggalSkPendirian
            ? formatDateOnly(data?.tanggalSkPendirian) || '-'
            : '-',
        },
        {
          key: 'no-sk-ops',
          displayName: 'No. SK Operasional',
          value: data?.skIzinOperasional || '-',
        },
        {
          key: 'tgl-sk-ops',
          displayName: 'Tanggal SK Operasional',
          value: data?.tanggalSkIzinOperasional
            ? formatDateOnly(data?.tanggalSkIzinOperasional) || '-'
            : '-',
        },
        {
          key: 'akreditasi',
          displayName: 'Akreditasi',
          value: data?.akreditasi || '-',
        },
      ]}
      classNames={{
        colKey: 'md:min-w-[200px]',
      }}
    />
  )
}
